module.exports = __webpack_public_path__ + "img/visuel-md.4caf0421.jpg";